let documentsCard = document.querySelector(".documents-card.proof_of_id")

if (documentsCard) {
  window.addEventListener("document:proof_of_id:upload:success", () => {
    // Subscription kyc docs page
    let nextPageBtn = document.querySelector("#subscription-kyc-doc-continue")
    if (nextPageBtn) {
      document.querySelector(".add-later-button").classList.add("invisible")
      nextPageBtn.classList.remove("d-none")
    }
  });
}